import { useEffect, useState } from 'react'
import { subDays, format } from "date-fns"

const AlarmData = (origin, menuItens, month, year, row, token, refreshTick) => {
    const [alarm, setAlarm] = useState({})

    useEffect(() => {
        getData().then(commands => {
            console.log("Dados recebidos do backend:", commands); // <-- Aqui!
            if (commands !== undefined) {
                // Gera labels dos últimos 30 dias
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const labelsUltimos30Dias = [];
                for (let i = 29; i >= 0; i--) {
                    const d = subDays(today, i);
                    labelsUltimos30Dias.push(format(d, "dd/MM"));
                }

                // Lista de centrais
                const menuList = origin === "client" ? [{ 'id_central': menuItens }] : menuItens;
                const menuItensList = menuList.map(item => item.id_central);

                // Filtra comandos da central e ignora "DESL"
                const requestCopy = commands.filter(item =>
                    menuItensList.includes(item.central) && item.occurrence !== "DESL"
                );

                // Tipos de comando para datasets separados
                const alarmTypes = [
                    { key: "LIGA", label: "ABANDONO", color: "#b71c1c" },
                    { key: "PANI", label: "BRIGADA", color: "#ffd600" },
                    { key: "SILE", label: "CALAR SIRENES", color: "#FFEA00" }
                ];

                // Monta datasets para cada tipo
                const general = alarmTypes.map(type => ({
                    label: type.label,
                    data: labelsUltimos30Dias.map(label => {
                        const [dia, mes] = label.split('/');
                        return requestCopy.filter(ev =>
                            ev.occurrence === type.key &&
                            String(ev.day).padStart(2, '0') === dia &&
                            String(ev.month).padStart(2, '0') === mes
                        ).length;
                    }),
                    showLine: true,
                    borderColor: type.color,
                    backgroundColor: type.color + "33"
                }));

                // Dataset geral (todos os comandos, exceto "DESL")
                const data = labelsUltimos30Dias.map(label => {
                    const [dia, mes] = label.split('/');
                    return requestCopy.filter(ev =>
                        String(ev.day).padStart(2, '0') === dia &&
                        String(ev.month).padStart(2, '0') === mes
                    ).length;
                });

                setAlarm({
                    labels: labelsUltimos30Dias,
                    datasets: {
                        label: "ALARMES",
                        data,
                        showLine: true,
                        borderColor: "",
                        backgroundColor: ""
                    },
                    general
                });
            }
        })
    }, [menuItens, token, refreshTick]);

    async function getData() {
        try {
            const endDate = new Date();
            endDate.setHours(0, 0, 0, 0);
            const startDate = subDays(endDate, 29);

            const startDateUTC = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
            const endDateUTC = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()));

            const response = await fetch(
                `${process.env.REACT_APP_URL}/command/relatory/by-period?occurrence=&startDate=${startDateUTC.toISOString().split('T')[0]}&endDate=${endDateUTC.toISOString().split('T')[0]}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Expose-Headers': '*',
                        'Authorization': 'Bearer ' + token
                    }
                }
            );
            if (!response.ok) return undefined;
            const json = await response.json();
            console.log("JSON retornado do backend:", json);
            return json;
        } catch (err) {
            console.error('Dashboard AlarmData: erro ao buscar dados', err);
            return undefined;
        }
    }

    return { alarm }
}

export default AlarmData
